import { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useRestaurant } from '@/contexts/RestaurantContext'
import { useGeneralSettings } from '@/features/general-settings/hooks/useGeneralSettings'
import { supportedLanguages, type SupportedLanguage } from '@/i18n'

/** Status texts are shown to the customer, so they use the restaurant's language, not the tablet's UI language. */
export function useCustomerStatusT() {
  const { i18n } = useTranslation()
  const { selectedRestaurant } = useRestaurant()
  const { settings } = useGeneralSettings(selectedRestaurant?.id ?? 0)
  const language: SupportedLanguage =
    supportedLanguages.find((supported) => supported === settings?.language) ?? 'de'

  useEffect(() => {
    void i18n.loadLanguages(language)
  }, [i18n, language])

  return useMemo(() => i18n.getFixedT(language, 'orders'), [i18n, language])
}
